export default "__VITE_ASSET__$Qq2evNI__"